/**
 * Copyright © 2026 Adnuntius AS.
 */
import {firstValueFrom} from 'rxjs';
import {Component, Inject, Input, OnInit, signal} from '@angular/core';
import template from './tier-list-page.component.html';
import * as _ from 'lodash';
import {AngularModalService} from '../../common/modal/angular-modal.service';

import {decorateTiersWithNetworkState} from './tier-commons';
import {TierPriorityModalComponent} from './tier-priority-modal.component';
import {NetworkApiService} from '../network/network-api.service';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {deferSignalViewWrite} from '../../common/util/template-state';
import {TierApiService} from './tier-api.service';
import {UIRouterModule} from '@uirouter/angular';
import {AppSharedModule} from '../../common/app-shared.module';

@Component({
  standalone: true,
  imports: [AppSharedModule, UIRouterModule],
  selector: 'adn-tier-list-page',
  template
})
export class TierListPageComponent implements OnInit {
  tiers: any[] = [];
  resolved = false;
  @Input() readOnly = false;
  readonly viewRevision = signal(0);
  private network: any;

  constructor(
    private readonly tierApi: TierApiService,
    @Inject(NetworkApiService) private Network: NetworkApiService,
    @Inject(LocalNetworkProfile) private LocalNetworkProfile: any,
    private angularModalService: AngularModalService
  ) {
  }

  ngOnInit(): void {
    this.loadTiers();
  }
  updatePriority(): void {
    const modalRef = this.angularModalService.show(TierPriorityModalComponent, {
      class: 'modal-lg',
      initialState: {inputNetwork: this.network}
    });
    (modalRef.content as TierPriorityModalComponent).onSaved.subscribe((updatedNetwork: any) => {
      this.network = updatedNetwork;
      this.loadTiers();
      this.LocalNetworkProfile.set('tiers', updatedNetwork.tiers);
    });
  }

  private loadTiers(): void {
    this.resolved = false;
    const tiersPromise = firstValueFrom(this.tierApi.listAll());
    const networkPromise = this.network || firstValueFrom(this.Network.get(this.LocalNetworkProfile.getNetworkId()));

    Promise.all([tiersPromise, networkPromise]).then((results: any[]) => {
      deferSignalViewWrite(this.viewRevision, () => {
        this.tiers = _.orderBy(decorateTiersWithNetworkState(results[0].results || [], results[1]), 'pos');
        this.network = results[1];
        this.resolved = true;
      });
    });
  }
}
